import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

const customIcons = {
  'solid-book-open-magnifying-glass': [
    640,
    512,
    [],
    'e000',
    'M0 83.8C0 71.7 6.8 60.5 18.1 56.1C46.3 45.3 93.5 32 144 32c58.4 0 103.4 20 123 35.6c3.4 2.6 5 6.8 5 11L272 456c0 11.4-11.6 19.3-22.4 15.5C223 462 177.9 448 144 448c-38.5 0-88.4 12.1-119.9 22.6C12.8 474.3 0 466 0 454.1L0 83.8zm304-5.2c0-4.2 1.7-8.4 5-11C328.6 52 373.6 32 432 32c50.5 0 97.7 13.3 125.9 24.2C569.2 60.5 576 71.7 576 83.8L576 224c-29.2-38.8-75.6-64-128-64c-63.4 0-118.1 36.8-144 90.1l0-171.5zm0 311.3c14 28.7 36.2 52.6 63.7 68.6c-15.6 4.2-30.1 9-41.3 13c-10.7 3.8-22.4-4.1-22.4-15.5l0-66.1zM320 320c0-70.7 57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L520 425.8l-.1 .1C499.4 439.8 474.7 448 448 448c-70.7 0-128-57.3-128-128zm48 0c0 28.6 15.2 55 40 69.3s55.2 14.3 80 0s40-40.7 40-69.3s-15.2-55-40-69.3s-55.2-14.3-80 0s-40 40.7-40 69.3z',
  ],
  'solid-file-lines-pen': [
    576,
    512,
    [],
    'e001',
    'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 139.7-94.7 94.7c-.6 .6-1.2 1.2-1.8 1.8c-1.7-7-8-12.2-15.5-12.2l-160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c1.1 0 2.2-.1 3.2-.3c-1.1 2.7-2 5.6-2.7 8.4l-15.1 60.1c-2.3 9.3-1.8 19 1.4 27.8L64 512c-35.3 0-64-28.7-64-64L0 64zM96 272c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zM256 0L384 128l-128 0L256 0zm33.5 492.1l15-60.1c1.4-5.7 4.3-10.8 8.4-14.9L442.2 287.9l-.1 0 71 71L383.9 488.1c-4.1 4.1-9.3 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2zM464.8 265.3l29.4-29.4c15.7-15.6 41-15.6 56.6 0l14.3 14.3c15.6 15.7 15.6 41 0 56.6l-29.4 29.4-70.9-70.9z',
  ],
};

const fakSolidBookOpenMagnifyingGlass = {
  icon: customIcons['solid-book-open-magnifying-glass'],
  iconName: 'solid-book-open-magnifying-glass',
  prefix: 'fak',
} as unknown as IconDefinition;

const fakSolidFileLinesPen = {
  icon: customIcons['solid-file-lines-pen'],
  iconName: 'solid-file-lines-pen',
  prefix: 'fak',
} as unknown as IconDefinition;

export const custom = {
  fakSolidBookOpenMagnifyingGlass,
  fakSolidFileLinesPen,
};
